import { useCareerData } from '../components/career-game/hooks/useCareerData';
import StreetScene from '../components/career-game/StreetScene';
import { config } from '../utils/config';

const CareerGame = () => {
  const { companies, loading, error } = useCareerData();

  if (loading) {
    return (
      <div className="text-center py-12">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-4 border-gray-300 border-t-blue-600"></div>
        <p className="text-gray-600 mt-4">Loading career journey...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <div className="text-red-600 mb-4">
          <h2 className="text-2xl font-bold mb-2">Error Loading Career Data</h2>
          <p>{error}</p>
        </div>
        <p className="text-sm text-gray-500">
          Make sure the career data is available at:{' '}
          <code className="bg-gray-100 px-2 py-1 rounded">{config.staticUrl}/career-data.json</code>
        </p>
      </div>
    );
  }

  if (companies.length === 0) {
    return (
      <div className="text-center py-12">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">No Career Data</h2>
        <p className="text-gray-600">
          No companies found in the career data. Please add your career history to the data file.
        </p>
      </div>
    );
  }

  return <StreetScene companies={companies} />;
};

export default CareerGame;
